import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TechnicalDocument} from '../../../../../../../providers/technical-documents/technical-documents.provider';

@Component({
    selector: 'std-table',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'std-table.component.html',
    styleUrls: ['std-table.component.scss'],
})

export class StdTableComponent {
    @Input() documents: TechnicalDocument[] = [];
}
